import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SapPriceCampaignBannerEntry } from '../../../../../core/model';
import { BadgeType } from '../../../badge';

@Component({
  selector: 'py-campaign-banner-carousel-item',
  templateUrl: './campaign-banner-carousel-item.component.html',
  styleUrls: ['./campaign-banner-carousel-item.component.scss'],
  standalone: false,
})
export class CampaignBannerCarouselItemComponent {
  readonly campaignBadgeType = BadgeType.Campaign;

  @Input() description: string;
  @Input() activeBannerEntry: SapPriceCampaignBannerEntry;
  @Input() isBannerEntryStopped: boolean;

  @Output() sendBannerEntryState = new EventEmitter<boolean>();

  toggleState(): void {
    this.sendBannerEntryState.emit(!this.isBannerEntryStopped);
  }
}
